import { useState } from 'react';
import { Link } from 'react-router-dom';

interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    setMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const menuItems = [
    { label: 'Philosophy', id: 'philosophy' },
    { label: 'Ensemble', id: 'ensemble' },
    { label: 'Credentials', id: 'credentials' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
        }`}
      >
        <div className="px-4 md:px-8 pt-4 pb-2 md:pt-5 md:pb-3">
          {/* 上段：ロゴ */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img
                src="https://public.readdy.ai/ai/img_res/79998c31-8dcb-4257-9950-200bb8348595.png"
                alt="Institute Logo"
                className="h-9 w-9 md:h-10 md:w-10 object-contain shrink-0"
              />
              <div className={`font-serif text-xs md:text-sm transition-colors leading-snug ${scrolled ? 'text-sumi' : 'text-white'}`}>
                <div className="whitespace-nowrap">Japanese Music Art</div>
                <div className="whitespace-nowrap">Expression Institute</div>
              </div>
            </div>

            {/* ハンバーガーボタン（モバイルのみ） */}
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className={`md:hidden w-8 h-8 flex flex-col items-center justify-center gap-1.5 cursor-pointer shrink-0 ${scrolled ? 'text-sumi' : 'text-white'}`}
              aria-label="Open menu"
            >
              <span className={`block w-5 h-px bg-current transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
              <span className={`block w-5 h-px bg-current transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`block w-5 h-px bg-current transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
            </button>
          </div>

          {/* 下段：メニュー（PCのみ） */}
          <div className="hidden md:flex items-center gap-8 mt-2">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`font-sans text-sm tracking-wide transition-all duration-300 relative group whitespace-nowrap cursor-pointer ${
                  scrolled ? 'text-sumi' : 'text-white'
                }`}
              >
                {item.label}
                <span className="absolute bottom-0 left-0 w-0 h-px bg-current transition-all duration-300 group-hover:w-full"></span>
              </button>
            ))}
            <Link
              to="/scores"
              className={`font-sans text-sm tracking-wide transition-all duration-300 relative group whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-sumi' : 'text-white'
              }`}
            >
              Scores
              <span className="absolute bottom-0 left-0 w-0 h-px bg-current transition-all duration-300 group-hover:w-full"></span>
            </Link>
            <Link
              to="/"
              className={`font-sans text-sm tracking-wide transition-all duration-300 relative group whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-sumi' : 'text-white'
              }`}
            >
              JP
              <span className="absolute bottom-0 left-0 w-0 h-px bg-current transition-all duration-300 group-hover:w-full"></span>
            </Link>
          </div>
        </div>
      </nav>

      {/* モバイルドロワーメニュー */}
      <div
        className={`fixed inset-0 z-40 md:hidden transition-all duration-300 ${
          menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        {/* 背景オーバーレイ */}
        <div
          className="absolute inset-0 bg-black/40"
          onClick={() => setMenuOpen(false)}
        ></div>

        {/* メニューパネル */}
        <div
          className={`absolute top-0 right-0 h-full w-64 bg-white shadow-xl transition-transform duration-300 ${
            menuOpen ? 'translate-x-0' : 'translate-x-full'
          }`}
        >
          <div className="pt-20 px-8 flex flex-col gap-6">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="font-sans text-sm tracking-wide text-sumi text-left cursor-pointer hover:opacity-60 transition-opacity whitespace-nowrap"
              >
                {item.label}
              </button>
            ))}
            <Link
              to="/scores"
              onClick={() => setMenuOpen(false)}
              className="font-sans text-sm tracking-wide text-sumi cursor-pointer hover:opacity-60 transition-opacity whitespace-nowrap"
            >
              Scores
            </Link>
            <Link
              to="/"
              onClick={() => setMenuOpen(false)}
              className="font-sans text-sm tracking-wide text-sumi cursor-pointer hover:opacity-60 transition-opacity whitespace-nowrap"
            >
              JP
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
